import React from "react";
import styles from "./Settings.module.css";

function Settings() {
  return (
    <div className={styles.settings_container}>
      <div className={styles.settings_body}>
        <h1>Settings Page</h1>
      </div>
    </div>
  );
}

export default Settings;
